<div class="topbar__container">
  <div class="topbar__logo">
    <a routerLink="/">
      <img src="{{logoUrl}}"/>
    </a>
  </div>

  <div class="topbar__user">
    <select *ngIf="workspaces.length >= 2" class="form-control" [(ngModel)]="selectedWorkspace" (change)="onWorkspaceChange(selectedWorkspace)">
      <option *ngFor="let workspace of workspaces" [value]="workspace.workspaceId">{{ getWorkspaceName(workspace) }}</option>
    </select>
    
    <div class="btn-group topbar__userdropdown" role="group">
      <button id="dropdown-user" type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div class="topbar__userimg">
          <div class="avatar-placeholder">{{ getUserInitials() }}</div>
        </div>
        <p>Olá, {{ getUserName() }}!</p>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdown-user">
        <ul>
          <!-- <li><a class="dropdown-item" href="#"><i class="fas fa-user"></i> Minha Conta</a></li> -->
          <!-- <li><a class="dropdown-item" href="#"><i class="fas fa-lock"></i> Alterar Senha</a></li> -->
          <li><a class="dropdown-item" href="https://forms.buildflex.io/atendimento/rRjg2rEPfUe67RsgKTJWJA/new" target="new"><i class="fas fa-comments"></i> Abrir Chamado</a></li>
          <li><a class="dropdown-item logout" (click)="logout()" ><i class="fas fa-sign-out-alt"></i>Sair</a></li>
        </ul>
        
      </div>
    </div>
  </div>
</div>